import _ from 'lodash';
import GlobalState from '../flux/GlobalState';

let isDev = false;
let devTools = null;

export default class DevelopmentUtils {

  static setDevMode() {
    isDev = true;
  }

  static isDev() {
    return isDev;
  }

  static isLocalhost(): boolean {
    return window.location.hostname === 'localhost';
  }

  /**
   * On atom, Nuclide > React > Toggle inspector
   */
  static initializeAtomReactInspector() {
    // on locahost only
    if (DevelopmentUtils.isDev() && DevelopmentUtils.isLocalhost()) {
      $('body').append(`<script src="http://localhost:8097"></script>`);
    }
  }

  static haveDevTools(): boolean {
    return DevelopmentUtils.isDev()
      && typeof window !== 'undefined'
      && window.__REDUX_DEVTOOLS_EXTENSION__;
  }

  static initializeDevTools(optionsParam = {}, appEvents = {}) {
    if (DevelopmentUtils.haveDevTools()) {
      const defaultOptions = {

      };

      const options = _.merge(defaultOptions, optionsParam);
      devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(options);

      GlobalState.appEvents = appEvents;

      // init dev tools with the globalState
      devTools.init(GlobalState.getGlobalState());

      // adds a change listener. It will be called any time an action is dispatched form the monitor. Returns a function to unsubscribe the current listener.
      devTools.subscribe(GlobalState.devToolsListener);
    } else {
      console.warn('No Redux dev tools found');
    }
  }

  static sendToDevTools(action, state) {
    if (DevelopmentUtils.haveDevTools()) {
      // weird bug without this :/
      const jsonState = JSON.parse(JSON.stringify(state));
      DevelopmentUtils.getDevTools().send(action, jsonState);
    }
  }

  static getDevTools() {
    return devTools;
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/utils/DevelopmentUtils.js